import { render } from "./ParameterCardItem.vue?vue&type=template&id=2bc41426"
import script from "./ParameterCardItem.vue?vue&type=script&lang=js"
export * from "./ParameterCardItem.vue?vue&type=script&lang=js"

import "./ParameterCardItem.vue?vue&type=style&index=0&id=2bc41426&lang=scss"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__